export const PAID = 'PAID';
export const UNPAID = 'UNPAID';
export const PAY = 'PAY';

export const NET = 'NET';
export const GROSS = 'GROSS';

export const INVOICE_PAYMENT_STATUS = [PAID, UNPAID];
export const INVOICE_SETTLEMENT_TYPES = [NET, GROSS];
